<style>
.v-list-item__title {
  white-space: normal;
}
</style>

<template>
  <v-stepper v-model="currentStep" vertical>
    <v-snackbar
      v-model="showSnackbar"
      :timeout="snackbarTimeout"
      top
      right
      elevation="0"
      class="snackbar-error-message"
    >
      {{ snackbarText }}
    </v-snackbar>

    <div class="px-6 pt-6">Please fill in the details below:</div>
      <Step01Recipient />

      <Step02Category v-on:showNextStep="showNextStep"/>

    <div v-if="!sendingDocument || (sendingDocument && requiresItmattForDocuments)">
      <Step03ContentItems ref="Step03ContentItems" />
      <!-- Hack: Wait till parent view has loaded countries before loading recipient step. -->
      <Step04Sender v-if="isMounted" />
      <!-- Hack: Wait till parent view has loaded countries before loading review step. -->
      <Step05Review v-if="isMounted" />
    </div>
  </v-stepper>
</template>

<script>
import Step02Category from "./Steps/Step02Category";
import Step01Recipient from "./Steps/Step01Recipient.vue";
import Step03ContentItems from "./Steps/Step03ContentItems.vue";
import Step04Sender from "./Steps/Step04Sender.vue";
import Step05Review from "./Steps/Step05Review.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("declarations");

export default {
  name: "Declaration",
  components: {
    Step02Category,
    Step01Recipient,
    Step03ContentItems,
    Step04Sender,
    Step05Review,
  },
  data: () => ({
    isMounted: false,
    saving: false,
  }),
  computed: {
    ...mapGetters([
      "sendingDocument",
      "currentStep",
      "snackbarTimeout",
      "snackbarText",
      "requiresItmattForDocuments",
    ]),
    showSnackbar: {
      set(isSnackbarVisible) {
        this.$store.dispatch(
          "declarations/setSnackbarVisibility",
          isSnackbarVisible
        );
      },
      get() {
        return this.$store.getters["declarations/showSnackbar"];
      },
    },
  },
  methods: {
    showNextStep(){
      
      this.$refs.Step03ContentItems.onShowTheStep();
    },
  },
  async mounted() {
    await this.$store.dispatch("declarations/pageLoad");
    this.isMounted = true;
  },  
};
</script>

<style scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

label.v-label.v-label--active {
  color: black;
}

.postCode .v-messages:before {
  content: "You can find your postcode on www.maltapost.com/postcode";
  color: #000;
}

.itemQuantity .v-messages:before {
  content: "How many items does your package contain?";
  color: #000;
}

.itemValue .v-messages:before {
  content: "If the actual value is not known, an estimation value of the total package should be listed";
  color: #000;
}
</style>
